import React, { useContext, useEffect, useState } from "react";
import { useFemaleFeedback } from "./store";
import { FeedbackDate } from "./FeedbackTab";
import FemaleSurveyPlan from "./FemaleSurveyPlan";
import FemaleSurveyTable from "./FemaleSurveyTable";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { useLocation, useNavigate } from "react-router-dom";

function FemaleSurveyComponent() {
  const {
    femaleFeedback,
    femaleFeedLoading,
    fetchFemaleFeedback,
    fetchFemaleFeedbackRating,
    femaleRatingData,
    femaleRatingLoading,
  } = useFemaleFeedback();

  const { startDate, endDate } = useContext(FeedbackDate);
  const [page, newPage] = useState(1);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get("tab");
  const pageNumber = parseInt(searchParams.get("page"));
  const [searchCount, setSearchCount] = useState(0);

  useEffect(() => {
    fetchFemaleFeedbackRating(startDate.valueOf(), endDate.valueOf());
  }, [startDate]);

  useEffect(() => {
    newPage(pageNumber);
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber) {
      fetchFemaleFeedback(startDate.valueOf(), endDate.valueOf(), pageNumber);
    }
  }, [pageNumber, startDate]);

  useEffect(() => {
    setSearchCount(searchCount + 1);
    if (page && pageNumber && searchCount) {
      navigate(`/feedback?tab=${tab}&page=${page}`);
    }
  }, [page]);

  return (
    <div>
      <FemaleSurveyPlan
        femaleRatingData={femaleRatingData?.satisfactionCounts}
        planLength={femaleRatingData?.totalDocument}
      />
      <div className="card p-2 mt-2">
        <FemaleSurveyTable
          femaleFeedback={femaleFeedback?.feedbacks}
          isLoading={femaleFeedLoading}
        />
        <PaginationDiv
          newPage={newPage}
          paginationData={{
            pageCount: femaleFeedback?.totalPage || 1,
            page: page,
          }}
        />
      </div>
    </div>
  );
}

export default FemaleSurveyComponent;
